/**
 * Constant values for EditorManager
 */
/**
 * Image plugin events
 * @hidden
 */
export var IMAGE = 'INSERT-IMAGE';
export var TABLE = 'INSERT-TABLE';
export var LINK = 'INSERT-LINK';
export var INSERT_ROW = 'INSERT-ROW';
export var INSERT_COLUMN = 'INSERT-COLUMN';
export var DELETEROW = 'DELETE-ROW';
export var DELETECOLUMN = 'DELETE-COLUMN';
export var REMOVETABLE = 'REMOVE-TABLE';
export var TABLEHEADER = 'TABLE-HEADER';
export var TABLE_VERTICAL_ALIGN = 'TABLE_VERTICAL_ALIGN';
/**
 * Alignments plugin events
 * @hidden
 */
export var ALIGNMENT_TYPE = 'alignment-type';
/**
 * Indents plugin events
 * @hidden
 */
export var INDENT_TYPE = 'indent-type';
/** Constant tag names
 * @hidden
 */
export var DEFAULT_TAG = 'p';
/**
 * @hidden
 */
export var BLOCK_TAGS = ['address', 'article', 'aside', 'audio', 'blockquote',
    'canvas', 'details', 'dd', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer',
    'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'li', 'main', 'nav',
    'noscript', 'ol', 'output', 'p', 'pre', 'section', 'table', 'tbody', 'td', 'tfoot', 'th',
    'thead', 'tr', 'ul', 'video'];
/**
 * @hidden
 */
export var IGNORE_BLOCK_TAGS = ['td', 'th'];
/**
 * @hidden
 */
export var TABLE_BLOCK_TAGS = ['table', 'tbody', 'td', 'tfoot', 'th',
    'thead', 'tr'];
/**
 * Selection plugin events
 * @hidden
 */
export var SELECTION_TYPE = 'selection-type';
/**
 * Insert HTML plugin events
 * @hidden
 */
export var INSERTHTML_TYPE = 'inserthtml-type';
/**
 * Insert Text plugin events
 * @hidden
 */
export var INSERT_TEXT_TYPE = 'insert-text-type';
/**
 * Clear Format HTML plugin events
 * @hidden
 */
export var CLEAR_TYPE = 'clear-type';
